export const companyHost = process.env.VUE_APP_COMPANY_HOST || 'teip';
